<template>
  <q-dialog :visible="isVisible" :title="title" width="80%" :innerScroll="false" :showFooter="false" @close="onCancel">
    <el-form ref="searchForm" :model="searchForm" :rules="rules" type="inline" v-loading="loading" size="mini">
      <div class="header">
        <el-form-item label="类型筛选：" prop="type">
          <el-radio-group v-model="searchForm.type" class="search-radio" @change="typeChange">
            <el-radio :label="1">展示全部</el-radio>
            <el-radio :label="2">仅展示有值</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>
    <div class="content">
      <el-table
        :data="tableData"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        style="width: 100%"
        height="65vh"
        ref="table"
        border
        v-loading="loading"
        v-if="isShowTable"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column v-for="item in visibleColumns" show-overflow-tooltip :prop="item.prop" :label="item.label" :key="item.prop" :min-width="item.width">
          <template slot-scope="scope">
            <template v-if="item.prop == 'productName'">
              <el-select
                v-model="scope.row.productName"
                filterable
                remote
                :remote-method="getProductNameKey"
                @blur="onSearchBlur"
                @change="onsearchChange(scope.row, scope.$index)"
              >
                <el-option v-for="item in productNameList" :label="item.productName" :value="item.productName" :key="item.productCode"></el-option>
              </el-select>
            </template>
            <template v-else>
              {{ scope.row[item.prop] }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button size="text" @click="onAdd(scope.$index)">新增 </el-button>
            <el-button size="text" @click="onDel(scope.$index)" v-show="tableData.length > 1" class="red-text-btn">删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'CRUDEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    selection: Array,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return 'DOM产品信息';
    },
    name() {
      return this.$store.state.user.name;
    },
    isAll() {
      return this.searchForm.type == 1;
    },
  },
  data() {
    return {
      loading: false,
      searchForm: {
        type: 2,
      },
      rules: {},
      tableData: [],
      columns: [
        { prop: 'productName', label: '产品名称', width: '200' },
        { prop: 'model', label: '型号', width: '80' },
        { prop: 'retailPrice', label: '外观', width: '80' },
        { prop: 'style', label: '风格', width: '90' },
        { prop: 'material', label: '产品主材质', width: '100' },
        { prop: 'fabric', label: '面料', width: '80' },
        { prop: 'productSize', label: '尺寸', width: '70' },
        { prop: 'color', label: '颜色', width: '70' },
        { prop: 'adapterMattress', label: '适配床垫', width: '80' },
        { prop: 'filler', label: '填充物', width: '80' },
        { prop: 'finishingProcess', label: '饰面工艺', width: '80' },
        { prop: 'updateDate', label: '发货周期', width: '80' },
        { prop: 'tableMaterial', label: '台面材质', width: '80' },
        { prop: 'functionality', label: '功能', width: '80' },
        { prop: 'handleType', label: '拉手类型', width: '80' },
      ],
      visibleColumns: [],
      productNameList: [],
      isShowTable: true,
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    async init() {},

    onAdd(index) {
      this.tableData.splice(index + 1, 0, { productName: '' });
    },
    onDel(index) {
      this.tableData.splice(index, 1);
    },
    updateVisibleColumns() {
      this.visibleColumns = this.columns.filter((col) => {
        return this.tableData.some((row) => row[col.prop]);
      });
    },
    typeChange(val) {
      val == 1 ? (this.visibleColumns = this.columns) : this.updateVisibleColumns();
    },
    async getProductNameKey(productName) {
      if (!productName || productName.length < 4) {
        this.productNameList = [];
        return;
      }
      const data = {
        filterData: { productName },
        pageNum: 1,
        pageSize: 99999,
      };
      this.productNameList = await this.$q.product
        .baseList({ data: data })
        .then(({ data }) => {
          return Array.isArray(data.records) ? data.records : [];
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },

    onSearchBlur() {
      setTimeout(() => {
        this.productNameList = [];
      }, 100);
    },
    async onsearchChange(row,index) {
      this.tableData[index] = this.productNameList.find((v) => v.productName == row.productName);
      this.isShowTable = false;
      this.$nextTick((_) => {
        this.isShowTable = true;
      });
    },
  },
  created() {
    this.tableData = [...this.selection];
    this.updateVisibleColumns();
  },
};
</script>

<style lang="stylus" scoped>
.header {
  display: flex
  height: 30px
  align-items: center
  flex-direction: row-reverse
  padding-bottom: 10px
}
.search-radio {
  width: 190px
}

>>> .el-form-item--mini{
  width: 280px;
}
>>> .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 0
}

>>> .el-dialog {
  margin-top: 50px !important
}
 .content >>> .el-date-editor, >>> .el-select, >>> .el-input {
  width: 100% !important;
}
</style>
